import LogRocket from "logrocket";
import setupLogRocketReact from "logrocket-react";
import { axiosPrivate } from "../../api/axios";
export default {
    init,
    login,
    logout,
};
function logout() {
    LogRocket.startNewSession();
}
function init() {
    LogRocket.init("qp19gk/mealtrackmulti", { mergeIframes: true });
    login();
    setupLogRocketReact(LogRocket);
}
function login() {
    axiosPrivate
        .get("/LogRocket")
        .then((res) => {
        if (res && res.data) {
            if (res.data.start_new_session) {
                LogRocket.startNewSession();
            }
            if (res.data.id) {
                if (res.data.user_data) {
                    LogRocket.identify(res.data.id, res.data.user_data);
                }
                else {
                    LogRocket.identify(res.data.id);
                }
            }
            if (res.data.event_name) {
                LogRocket.track(res.data.event_name, res.data.event_properties);
            }
        }
    })
        .catch((error) => {
        return;
    });
}
